/** Límite usado cuando el programa no trae `limiteIntentos`. */
export const LIMITE_INTENTOS_DEFAULT = 3;

export interface IntentosInfo {
  usados: number;
  total: number;
  restantes: number;
  agotados: boolean;
}

/**
 * Calcula los intentos de un aprendiz en una actividad.
 * El total es el límite del programa más los intentos extra asignados.
 */
export function getIntentosInfo({
  intentos,
  intentosExtras,
  limiteIntentos,
}: {
  intentos?: number | null;
  intentosExtras?: number | null;
  limiteIntentos?: number | null;
}): IntentosInfo {
  const usados = intentos ?? 0;
  const total = (limiteIntentos ?? LIMITE_INTENTOS_DEFAULT) + (intentosExtras ?? 0);
  const restantes = Math.max(total - usados, 0);
  return { usados, total, restantes, agotados: usados >= total };
}
